import loginRedux from '../../views/login/redux/slice'
import recoveryPasswordRedux from '../../views/recoveryPassword/redux/slice'
import authRedux from '../../auth/redux/slice'

//export redux objects
export default {
    loginRedux,
    recoveryPasswordRedux,
    authRedux
};